import { Link } from 'react-router-dom';
import { isAuthorized } from '../../utils/Auth/auth';

const Home = () => {
  const getTitle = (isAuth) => {
    if (isAuth) {
      return (
        <div className="mt-28">
          Welcome to{' '}
          <span className="font-semibold">
            M<span className="text-red-700">e</span>est
          </span>{' '}
          <br></br>employee portal!
          <div className="text-xl mt-28">
            <span className="font-normal">Usefull links:</span>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.mymeest.ca/MeestPortal/login"
              className="bg-blue-900 text-white flex justify-center items-center w-[30rem] relative rounded-full px-4 py-1 mx-auto my-3 hover:bg-blue-800 hover:transition-all hover:duration-300"
            >
              To open the client portal, click here
              <div className="inline-block ml-auto">{'>'}</div>
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.mymeest.ca"
              className="bg-red-800 text-white flex justify-center items-center w-[30rem] relative rounded-full px-4 py-1 mx-auto my-3 hover:bg-red-900 hover:transition-all hover:duration-300"
            >
              To open the agent portal, click here
              <div className="inline-block ml-auto">{'>'}</div>
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://ca.meest.com/parcel-track"
              className="bg-blue-900 text-white flex justify-center items-center w-[30rem] relative rounded-full px-4 py-1 mx-auto my-3 hover:bg-blue-800 hover:transition-all hover:duration-300"
            >
              For tracking parcels, click here
              <div className="inline-block ml-auto">{'>'}</div>
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://ca.meest.com/offices"
              className="bg-blue-900 text-white flex justify-center items-center w-[30rem] relative rounded-full px-4 py-1 mx-auto my-3 hover:bg-blue-800 hover:transition-all hover:duration-300"
            >
              To search for an agent location, click here
              <div className="inline-block ml-auto">{'>'}</div>
            </a>
          </div>
        </div>
      );
    }
    return (
      <div className="mt-40">
        Please authorize to use{' '}
        <span className="font-semibold">
          M<span className="text-red-700">e</span>est
        </span>{' '}
        <br />
        employee portal features!
        <br />
        <Link
          to="/signIn"
          className="bg-blue-800 text-white inline-block rounded-[65px] text-[25px] pl-8 pr-5 hover:bg-blue-900 cursor-pointer"
        >
          {'SIGN IN >'}
        </Link>
      </div>
    );
  };
  return (
    <div className="text-[38px] text-blue-800 font-thin">
      {getTitle(isAuthorized)}
    </div>
  );
};

export default Home;
